import { ApiActionType } from 'api/volops';

export const ACTION_TYPE: Array<{
  id: ApiActionType | 'NONE';
  name: string;
}> = [
  {
    id: 'NONE',
    name: '',
  },
  {
    id: 'VOLOP',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Volunteer Opportunity'),
  },
  {
    id: 'EVENT',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Event'),
  },
  {
    id: 'LOAN',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Loan'),
  },
  {
    id: 'DONATION',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Donation'),
  },
  {
    id: 'PETITION',
    name:
      /* TRANSLATORS: Action Opp type */
      getText('Petition'),
  },
  {
    id: 'OTHER',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Other Opportunity'),
  },
];
